import { NgModule } from '@angular/core';
import { TinymceModule } from 'angular2-tinymce';
import { ReleaseNoteModalModule } from './modals/release-note-modal.module';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/imagetools/plugin';
import { BaseModule } from '../../shared/base.module';
import { baseUrl } from '../../../environments/environment';
import { SharedPopoverModule } from '../../shared/popover/popover.module';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReleaseNoteComponent } from './release-note.component';
import { DialogModule } from '../../dialog/dialog.module';
import { BreadcrumbModule } from '../../shared/breadcrumb/breadcrumb.module';
import { ReleaseNoteService } from './release-note.service';

@NgModule({
    imports: [
        BaseModule,
        TinymceModule.withConfig({
            plugins: ['image', 'imagetools', 'code'],
            images_upload_url: baseUrl + 'image-upload',
            menubar: false,
            elementpath: false,
            toolbar: 'bold italic alignleft numlist bullist link formatselect image code | removeformat',
        }),
        ReleaseNoteModalModule,
        SharedPopoverModule,
        RouterModule,
        DialogModule,
        DragDropModule,
        BreadcrumbModule
    ],
    declarations: [
        ReleaseNoteComponent
    ],
    providers: [
        ReleaseNoteService
    ]
})
export class ReleaseNoteModule {
}
